export default __webpack_public_path__ + "static/media/mc_pulse_black.c66a5130.svg";